import { Routes, Route } from "react-router-dom"
import Dashboard from './pages/Dashboard'
import Home from "./pages/Home"

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/dashboard/:userId/" element={<Dashboard />} />
    </Routes>
  )
}